import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseCompany } from "./UseCompany";

export default function CompanyAutoComplete(props) {
  const { getAllCompanyList } = UseCompany();
  const [productCompanyRes, setProductCompanyRes] = useState();
  const [selectedCompany, setSelectedCompany] = useState();

  useEffect(() => {
    getAllCompanyList((company) => {
      setProductCompanyRes(company);
    });
  }, []);

  useEffect(() => {
    if (productCompanyRes && props.selectedCompanyID) {
      setSelectedCompany(
        productCompanyRes.companies.find((m) => m.id == props.selectedCompanyID)
      );
    }
  }, [productCompanyRes, props.selectedCompanyID]);

  useEffect(() => {
    if (selectedCompany) {
      props.setter({
        ...props.lvl1State,
        companyID: selectedCompany.id,
      });
    }
  }, [selectedCompany]);

  return productCompanyRes ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        value={selectedCompany ? selectedCompany : ""}
        options={productCompanyRes.companies ? productCompanyRes.companies : []}
        getOptionLabel={(company) => (company.faName ? company.faName : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField {...params} label="شرکت" error={props.validation} />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.faName ? option.faName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedCompany(newValue);
          } else {
            setSelectedCompany();
            props.setter({
              ...props.lvl1State,
              companyID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllCompanyList((company) => {
            setProductCompanyRes(company);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/companies" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
